import React, { ReactElement } from 'react';
import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import FileUpload from './FileUpload';
import ImageButton from './Buttons/ImageButton';

const translateActivities = (key) => translate('activities', key);

type Props = {
  onClickCamera: () => void;
  onFileUpload: (file) => void;
  onClose: () => void;
};

const UploadPage = ({ onClickCamera, onFileUpload, onClose }: Props): ReactElement => {
  const { containerClass, wrapperTakePhotoClass, textClass, buttonContainer, closeButton } =
    useStyles();

  return (
    <Box className={containerClass}>
      <ImageButton onClick={onClose} className={closeButton} imageName={'rejectButton'} />
      <Box className={buttonContainer}>
        <Box className={wrapperTakePhotoClass}>
          <ImageButton onClick={onClickCamera} imageName={'photoButton'} />
          <Typography variant="body2" className={textClass}>
            {translateActivities('takePhoto')}
          </Typography>
        </Box>
        <FileUpload onUpload={onFileUpload} />
      </Box>
    </Box>
  );
};

export default UploadPage;

const useStyles = makeStyles((theme) => ({
  containerClass: {
    backgroundColor: 'white',
    padding: remCalc(10),
    position: 'relative',
  },
  wrapperTakePhotoClass: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'center',
    marginBottom: remCalc(8),
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: remCalc(50),
    marginTop: remCalc(70),
  },
  textClass: {
    paddingTop: remCalc(16),
    [theme.breakpoints.down('md')]: {
      fontSize: '4vmin',
      textAlign: 'center',
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: remCalc(8),
    },
  },
  closeButton: {
    position: 'absolute',
    right: 10,
    top: 10,
  },
}));
